module.exports = __webpack_public_path__ + "fonts/icons-zaki.42512da.ttf";